import React from 'react';
import ProtectedRoute from './protected';
import TrainingPage from '../pages/employee-training';
import EmployeeTraining from '../pages/employee-training/EmployeeTraining';

export const TrainingRoutes = [
  <ProtectedRoute exact path='/training' component={EmployeeTraining} />,
]